// Moments block — wide image Swiper carousel.
import Swiper, { FreeMode, Mousewheel } from 'imports/swiper'

const homeMoments = {
    init() {
        document.querySelectorAll('[data-home-moments]').forEach((el) => {
            new Swiper(el, {
                modules: [FreeMode, Mousewheel],
                slidesPerView: 'auto',
                spaceBetween: 16,
                freeMode: true,
                grabCursor: true,
                mousewheel: {
                    forceToAxis: true,
                },
            })
        })
    }
}

export default homeMoments
